module.exports = __webpack_public_path__ + "41274fc221d9fe727256b3f302904a4e.ttf";